<!--
 * @Author: your name
 * @Date: 2021-11-11 12:50:34
 * @LastEditTime: 2022-05-07 22:40:04
 * @LastEditors: liuwujiang@easyretailpro.com liuwujiang@easyretailpro.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \tongxing\src\views\home.vue
-->
<template>
    <div class="container page">
        <mini-navbar-sub :title="title"></mini-navbar-sub>
        <div class="content">
            <div class="stage" v-for="(item, index) in list" :key="index">
                <div class="stage__title-bar flex-mode" :style="{ marginTop: hasOpen(item.id)?'': '16px' }" @click="open(item.id)">
                    <template v-if="hasOpen(item.id)">
                        <img class="icon" src="@/assets/images/icons/arrow-bottom-open.png" />
                    </template>
                    <template v-else>
                        <div :class="[index == 0?'short-line': 'line']"></div>
                        <img class="icon--close" src="@/assets/images/icons/arrow-close.png" />
                    </template>
                    <div class="title">{{parseInt(index + 1) | NumberToChinese}}、{{item.categoryName}}</div>
                </div>
                <template v-if="hasOpen(item.id)">
                    <div class="stage__detail" v-for="(item1, index1) in item.children" :key="index1" @click="nextTo(item1, item.categoryName)">
                        <div class="stage__detail-line"></div>
                        <img class="stage__detail-point" src="@/assets/images/icons/point.png" />
                        <div class="remark">
                            <div class="text">{{parseInt(index1 + 1)}}. {{item1.categoryName}}</div>
                            <div class="time">更新日期：{{item1.updated | ToString('yyyy-mm-dd')}}</div>
                        </div>
                    </div>
                </template>
            </div>
            <!-- <div class="footer-bar"> -->
                <img src="@/assets/images/sucai/doll.png" class="footer-icon" alt="">
            <!-- </div> -->
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            id: 0,
            title: '经销商手册',
            active: 1,
            activeStages: [],
            list: []
        }
    },
    components: {  
    },
    created() {
        var routeParams = this.$route.query
        this.id = routeParams.id
        this.title = routeParams.title
        this.getList()
    },
    computed: {
        hasOpen() {
            return function(id) {
                let activeList = this.activeStages
                if(!activeList || activeList.length == 0) return false
                if(activeList.findIndex(e=> e == id) != -1) return true
                return false
            }
        }
    },
    methods: {
        getList() {
            this.$api.studyCategoryClient.queryAllStudyCategory().then(res=> {
                if(res && res.length > 0) {
                    let item = res.find(e=> e.categoryName == this.title)
                    if(item && item.children && item.children.length > 0) {
                        this.list = item.children
                        this.activeStages = [item.children[0].id]
                    }
                }
            })
        },
        open(id) {
            let activeList = this.activeStages
            let index= activeList.findIndex(e=> e == id)
            if(index == -1) {
                activeList.push(id)
            }else{
                activeList.splice(index, 1)
            }
        },
        nextTo(item, catalogueName) {
            this.$router.push({
                name: 'lesson-list',
                query: {
                    id: item.id,
                    catalogueName: catalogueName
                }
            })
        },
    }
}
</script>
<style lang="less" scoped>
    @import './index.less';
</style>